import {
  Col,
  Form,
  Image,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  InputNumber,
  DatePicker,
} from "antd";
import React, { useEffect, useState } from "react";

import notfound from "../../assets/images/not_found.png";
import SingleImageUpload from "../../components/SingleImageUpload";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import moment from "moment";

const AddForm = ({ api, show, hide, data, refresh, section, contentType }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [image, setImage] = useState();
  const [image2, setImage2] = useState();
  const [loading, setLoading] = useState(false);
  const supportedVideoExtensions = [".mp4", ".ogg", ".webm", ".mpeg"];
  const imageFileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/avif",
    "image/webp",
  ];
  const videoFileType = [
    "video/mp4",
    "video/ogg",
    "video/webm",
    "video/mpeg",
  ];

  const handleImage = (data) => {
    data.length > 0 ? setImage(data[0].url) : setImage([]);
  };

  const handleImage2 = (data) => {
    data.length > 0 ? setImage2(data[0].url) : setImage2([]);
  };

  useEffect(() => {
    if (!data) return;
    console.log(data);
    form.setFieldsValue({
      ...data,
      image: data.url,
      src: data.src,
      scheduler_time: data?.scheduler_time ? moment(data?.scheduler_time) : "",
    });
    setImage(data.url);
    setImage2(data.src);
  }, [data]);

  const onCreate = (values) => {
    console.log(values, "values");
    setLoading(true);
    const payload = {
      ...values,
      type: contentType
    };

    if (image?.length > 0) {
      payload.url = image;
    }
    if (image2?.length > 0) {
      payload.src = image2;
    }

    request({
      url: `${data ? api.addEdit + "/" + data._id : api.addEdit}`,
      method: data ? "PUT" : "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error?.response?.data?.message, Severty.ERROR);
        setLoading(false);
      },
    });
  };

  return (
    <Modal
      open={show}
      maskClosable={false}
      width={750}
      okText={data ? `Update` : `Add`}
      cancelText={`Cancel`}
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="tab_modal"
    >
      <Form
        id="create"
        form={form}
        onFinish={onCreate}
        layout="vertical"
        initialValues={{
          is_active: true,
        }}
      >
        <h4 className="modal_title_cls">
          {data ? `Edit ` : `Add New `} {section}
        </h4>
        <Row gutter={[16, 0]}>
          <Col span={24} sm={12}>
            <Form.Item
              label={<> {`${section} Title`}</>}
              name="title"
              rules={[
                {
                  required: true,
                  message: "Title is required",
                },
                {
                  max: 200,
                  message: "Title should not contain more then 200 characters!",
                },
                {
                  min: 2,
                  message: "Title should contain at least 2 characters!",
                },

              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input autoComplete="off" placeholder={`Enter Title`} />
            </Form.Item>
          </Col>
          {contentType === "Video" ?
            <Col span={24} sm={24} md={12}>
              <Form.Item
                className="username "
                name="scheduler_time"
                label="Scheduler Time"
                rules={[
                  {
                    required: true,
                    message: "Please select scheduler  Date!",
                  },
                ]}
              >
                <DatePicker
                  disabled={data?.is_uploaded ? true : false}
                  className="date-inn"
                  placeholder={"Enter Scheduler Date"}
                  format="DD-MM-yyyy HH:mm"
                  showTime={{
                    format: "HH:mm", // Time format
                  }}
                  disabledDate={(current) => {
                    return current && current < moment().startOf("day");
                  }}
                />
              </Form.Item>
            </Col> :
            <Col span={24} sm={12}>
              <Form.Item
                label={<> {"Day Number"}</>}
                name="day_number"

                rules={[
                  {
                    required: true,
                    message: "Day Number is required",
                  },
                  {
                    validator: (_, value) => {
                      if (value <= 0) {
                        return Promise.reject("Day Number must be greater than zero");
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <InputNumber
                  autoComplete="off"
                  placeholder={`Enter Day Number`}
                />
              </Form.Item>
            </Col>}

          <Col span={24} sm={12}>
            <Form.Item
              label={"User Name"}
              name="name"
              rules={[
                {
                  required: true,
                  message: "User Name is required",
                },
                {
                  max: 200,
                  message: "User Name should not contain more then 200 characters!",
                },
                {
                  min: 2,
                  message: "User Name should contain at least 2 characters!",
                },

              ]}
              normalize={(value) => value.trimStart()}
            >
              <Input autoComplete="off" placeholder={`Enter User Name`} />
            </Form.Item>
          </Col>

          <Col span={24} sm={12}>
            <Form.Item
              className=""
              rules={[
                {
                  validator: (_, value) => {
                    if (value !== undefined && value?.length > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(`${contentType} is required`));
                  },
                },
              ]}
              label={"User Image"}
              name="src"
            >
              <SingleImageUpload
                value={image2}
                fileType={imageFileType}
                imageType={"Content"}
                btnName={"User Image"}
                onChange={(data) => handleImage2(data)}
                isDimension={false}
                setLoading={setLoading}
              />
            </Form.Item>
            {/* {image2 && image2?.length ? (
              <div className="mt-2 add-img-product">
                <Image width={120} src={image2 ?? notfound} />
              </div>
            ) : ""} */}
          </Col>


          <Col span={24}>
            <Form.Item
              className=""
              rules={[
                {
                  validator: (_, value) => {
                    if (value !== undefined && value?.length > 0) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error(`${contentType} is required`));
                  },
                },
              ]}
              label={"Video Content"}
              name="image"
            >
              <SingleImageUpload
                value={image}
                fileType={contentType === "Video" ? videoFileType : imageFileType}
                imageType={"Content"}
                btnName={"Video Content"}
                onChange={(data) => handleImage(data)}
                isDimension={false}
                setLoading={setLoading}
              />
            </Form.Item>
            {image && image?.length ? (
              <div className="mt-2 add-img-product">
                {typeof image === "string" &&
                  supportedVideoExtensions?.some((ext) =>
                    image.toLowerCase().endsWith(ext)
                  ) ? (
                  <video controls src={image} />
                ) : (
                  <Image width={120} src={image ?? notfound} />
                )}
              </div>
            ) : ""}
          </Col>

        </Row>
      </Form>
    </Modal>
  );
};

export default AddForm;
